"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cotopaxi_1 = require("@as/cotopaxi");
exports.default = (asset_base_path) => (0, cotopaxi_1.preloadAssetFileGenerator)(asset_base_path);
